import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { AccountViewModel } from "@tylertech/tyler-api-types";
import { AccountBudgetRecapTableComponent } from "./accountBudgetRecapTable.component";

export interface AccountBudgetRecapDialogData
{
    readonly accounts: Array<AccountViewModel>;
    readonly summaryDate: Date | string;
}

@Component({
    selector: "gl-account-budget-recap-dialog",
    templateUrl: "./accountBudgetRecapDialog.tmpl.html",
    imports: [
        AccountBudgetRecapTableComponent,
        CdkScrollable,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
    ]
})
export class AccountBudgetRecapDialogComponent
{
    private readonly data = inject<AccountBudgetRecapDialogData>(MAT_DIALOG_DATA);


    get accounts(): Array<AccountViewModel> { return this.data.accounts; }
    get summaryDate(): Date | string { return this.data.summaryDate; }
}
